module.exports = __webpack_public_path__ + "static/media/infrastructure.0958191b.svg";